import React, { useState } from "react";
import { sendData } from "../../Config/FirebaseMethod";
import {
  Alert,
  CircularProgress,
  FormHelperText,
  Snackbar,
} from "@mui/material";
import Loader from "../Loader/Loader";
import axios from "axios";

const FeedForm = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [msg, setMsg] = useState("");
  const [errormsg, setErrormsg] = useState("");
  const [open, setOpen] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [alertMessage, setAlertMessage] = useState("");
  const [name, setName] = useState("");
  const [subject, setSubject] = useState("");
  const [email, setEmail] = useState("");
  const [suggestions, setSuggestions] = useState("");
  const [category, setCategory] = useState("user");
  const FeedbackKey = process.env.REACT_APP_FEEDBACK_KEY;

  let signUp = () => {
    setIsLoading(true);
    sendData({ name, email, subject, suggestions, category }, "Feedback")
      .then((success) => {
        setIsLoading(false);
        setAlertSeverity("success");
        setAlertMessage(success);
        setOpen(true);
        setError(false);
      })
      .catch((error) => {
        setError(true);
        setIsLoading(false);
        setAlertSeverity("error");
        setAlertMessage(error);
      });
  };

  let handleSubmit = (e) => {
    signUp();
    axios
      .post(FeedbackKey, {
        name: name,
        email: email,
      })
      .then((response) => {
        console.log("Email sent successfully");
        // Handle success, e.g., show a success message
      })
      .catch((error) => {
        console.error("Email send failed", error);
        // Handle error, e.g., show an error message
      });
    e.preventDefault();
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  return (
    <div className="container mt-3 mb-5">
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label for="exampleInputEmail1" className="form-label">
            Your Name
          </label>
          <input
            type="text"
            className="form-control"
            id="exampleInputEmail1"
            aria-describedby="emailHelp"
            required
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label for="exampleInputEmail1" className="form-label">
            Email address
          </label>
          <input
            type="email"
            className="form-control"
            id="exampleInputEmail1"
            aria-describedby="emailHelp"
            required
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label for="exampleInputEmail1" className="form-label">
            Subject
          </label>
          <input
            type="text"
            className="form-control"
            id="exampleInputEmail1"
            aria-describedby="emailHelp"
            required
            onChange={(e) => setSubject(e.target.value)}
          />
        </div>

        <div class="mb-3">
          <label for="exampleFormControlTextarea1" class="form-label">
            Your Suggestions
          </label>
          <textarea
            class="form-control"
            id="exampleFormControlTextarea1"
            required
            rows="3"
            onChange={(e) => setSuggestions(e.target.value)}
          ></textarea>
        </div>

        <button type="submit" className="btn-login">
          {isLoading ? <CircularProgress /> : "Submit"}
        </button>
      </form>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert severity={alertSeverity} sx={{ width: "100%" }}>
          {alertMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default FeedForm;
